import qs from 'query-string';
import { performGetRequest, performPutRequest } from '@atlassian/jira-fetch/src/utils/requests';
import catchAndLogFetchError from '@atlassian/jira-project-settings-apps-common/src/util/catch-and-log-fetch-error';
import type { Context, AccessType } from '../../types';

export type ProjectAccessTypesResponse = {
	accessTypes: AccessType[];
};

type ProjectAccessTypesService = {
	getProjectAccessTypes(context: Context): Promise<ProjectAccessTypesResponse>;
	updateProjectAccessType(context: Context, accessType: string): Promise<AccessType>;
};

export const getProjectAccessTypesUrl = ({ baseUrl, projectType }: Context): string =>
	`${baseUrl}/rest/internal/simplified/1.0/accesslevel?${qs.stringify({ projectType })}`;

export const updateAccessTypeEndpoint = (context: Context): string =>
	`${getProjectAccessTypesUrl(context)}/project/${context.projectId || ''}`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toProjectAccessTypesResponse = (json: any): ProjectAccessTypesResponse => ({
	accessTypes: json,
});

const projectAccessTypesService: ProjectAccessTypesService = {
	getProjectAccessTypes: (context: Context): Promise<ProjectAccessTypesResponse> =>
		catchAndLogFetchError(
			performGetRequest(getProjectAccessTypesUrl(context)),
			'Failed to fetch access types for a project',
		).then(toProjectAccessTypesResponse),
	updateProjectAccessType: (context: Context, accessLevel: string): Promise<AccessType> =>
		catchAndLogFetchError(
			performPutRequest(updateAccessTypeEndpoint(context), {
				body: JSON.stringify({ accessLevel }),
			}),
			'Failed to update access types for a project',
		),
};

export default projectAccessTypesService;
